import { useCurrentSite } from "../../../contexts/models/SiteContext";
import { isEmptySlateDocument } from "../../../core/constants";
import { TextDetails } from "../../../resources/modelTypes";
import { SectionComponentProps } from "../../types";
import { ThemedRichText } from "./ThemedRichText";
import { SmallHeadline, TinyHeadline } from "@minted/fancyclothes";
import React, { memo } from "react";

const DisplayTextSection = ({ section }: SectionComponentProps) => {
  const site = useCurrentSite();
  const { isWedding } = site;
  const details = section.sectionDetails as TextDetails;

  return (
    <>
      {Boolean(details.title) &&
        (isWedding ? (
          <SmallHeadline>{details.title}</SmallHeadline>
        ) : (
          <TinyHeadline>{details.title}</TinyHeadline>
        ))}
      {!isEmptySlateDocument(details.content) && (
        <ThemedRichText content={details.content} />
      )}
    </>
  );
};

const MemoizedDisplayImageAndText = memo(DisplayTextSection);

export { MemoizedDisplayImageAndText as DisplayTextSection };
